//#region src/bite_log_expo_printer_event.ts
var BiteLogExpoPrinterEvent = /* @__PURE__ */ function(BiteLogExpoPrinterEvent) {
	BiteLogExpoPrinterEvent[BiteLogExpoPrinterEvent["GetPrintJobsSuccessWithOrders"] = 1] = "GetPrintJobsSuccessWithOrders";
	BiteLogExpoPrinterEvent[BiteLogExpoPrinterEvent["SetPrintResponse"] = 2] = "SetPrintResponse";
	return BiteLogExpoPrinterEvent;
}(BiteLogExpoPrinterEvent || {});
//#endregion
export { BiteLogExpoPrinterEvent };

//# sourceMappingURL=bite_log_expo_printer_event.js.map